// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/endpoint_service.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import type { Endpoint } from "./endpoint_pb";
import type { BigIntString } from "../../../../../runtime";
import { RPC } from "../../../../../runtime";

/**
 * The request message for creating an endpoint.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CreateEndpointRequest
 */
export type CreateEndpointRequest = {
/**
 * The parent name where the endpoint is to be created, in the form:
 * "workspaces/{workspace}"
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * The endpoint to create.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Endpoint endpoint = 2;
 */
endpoint: Endpoint;
}
;
/**
 * The response message for creating an endpoint.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CreateEndpointResponse
 */
export type CreateEndpointResponse = {
/**
 * The created endpoint.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Endpoint endpoint = 1;
 */
endpoint?: Endpoint;
}
;
/**
 * The request message for getting an endpoint.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetEndpointRequest
 */
export type GetEndpointRequest = {
/**
 * The name of the endpoint to get, in the form:
 * "workspaces/{workspace}/endpoints/{endpointId}"
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * The response message for getting an endpoint.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetEndpointResponse
 */
export type GetEndpointResponse = {
/**
 * The retrieved endpoint.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Endpoint endpoint = 1;
 */
endpoint?: Endpoint;
}
;
/**
 * The request message for listing endpoints.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListEndpointsRequest
 */
export type ListEndpointsRequest = {
/**
 * The endpoint's parent name, in the form:
 * "workspaces/{workspace}"
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Optional. The maximum number of results to return. A response's page
 * size may differ at the discretion of the server, especially for the
 * purpose of capping response size.
 *
 * @generated from field: int32 page_size = 2;
 */
pageSize?: number;
/**
 * Optional. The `next_page_token` value returned from a previous call, used
 * to get the next set of results.
 *
 * @generated from field: string page_token = 3;
 */
pageToken?: string;
/**
 * When used, server will only return endpoints that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 *
 * Supported fields:
 *   * display_name
 *   * description
 *   * path
 *   * target
 *   * create_time
 *   * update_time
 *
 * Examples:
 * display_name = 'Some display' OR create_time <= 2023-12-30T23:59:43Z
 * create_time >= timestamp('2023-12-30T23:59:43Z') AND create_time <= timestamp('2024-03-20T08:00:00Z')
 * NOT(display_name = 'Some display name' OR create_time <= timestamp('2023-12-30T23:59:43Z'))
 *
 * @generated from field: string filter = 4;
 */
filter?: string;
/**
 * When used, server will return endpoints ordered by the specified fields.
 * Attempts to implement AIP-132 (https://aip.dev/132#ordering).
 * Supported fields are the ones supported by filter.
 *
 * @generated from field: string order_by = 5;
 */
orderBy?: string;
}
;
/**
 * The response message for listing endpoints.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListEndpointsResponse
 */
export type ListEndpointsResponse = {
/**
 * The endpoints.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.Endpoint endpoints = 1;
 */
endpoints?: Endpoint[];
/**
 * If present, signals that more results from the request are available.
 * Use this as another request's `page_token` value. The field values of
 * subsequent requests must be identical to the previous one.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * The request message for counting endpoints.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CountEndpointsRequest
 */
export type CountEndpointsRequest = {
/**
 * The endpoint's parent name, in the form:
 * "workspaces/{workspace}"
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * When used, server will only count endpoints that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 *
 * Supported fields:
 *   * display_name
 *   * description
 *   * path
 *   * target
 *   * create_time
 *   * update_time
 *
 * Examples:
 * display_name = 'Some display' OR create_time <= 2023-12-30T23:59:43Z
 * create_time >= timestamp('2023-12-30T23:59:43Z') AND create_time <= timestamp('2024-03-20T08:00:00Z')
 * NOT(display_name = 'Some display name' OR create_time <= timestamp('2023-12-30T23:59:43Z'))
 *
 * @generated from field: string filter = 2;
 */
filter?: string;
}
;
/**
 * The response message for counting endpoints.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CountEndpointsResponse
 */
export type CountEndpointsResponse = {
/**
 * Number of endpoints.
 *
 * @generated from field: int64 count = 1;
 */
count?: BigIntString;
}
;
/**
 * The request message for updating an endpoint.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpdateEndpointRequest
 */
export type UpdateEndpointRequest = {
/**
 * The endpoint to update, where the endpoint's `name` field is used to
 * identify the one to update.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Endpoint endpoint = 1;
 */
endpoint: Endpoint;
/**
 * The fields to update.
 * Allowed field paths are: { "display_name", "description", "target" }
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 2;
 */
updateMask?: string;
}
;
/**
 * The response message for updating an endpoint.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpdateEndpointResponse
 */
export type UpdateEndpointResponse = {
/**
 * The updated endpoint.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Endpoint endpoint = 1;
 */
endpoint?: Endpoint;
}
;
/**
 * The request message for deleting an endpoint.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteEndpointRequest
 */
export type DeleteEndpointRequest = {
/**
 * The name of the endpoint to delete, in the form:
 * "workspaces/{workspace}/endpoints/{endpoint}"
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * The response message for deleting an endpoint.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteEndpointResponse
 */
export type DeleteEndpointResponse = {
}
;
/**
 * Creates an endpoint.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.EndpointService.CreateEndpoint
 */
export const EndpointService_CreateEndpoint = new RPC<CreateEndpointRequest,CreateEndpointResponse>("POST", "/v2/{parent=workspaces/*}/endpoints", "endpoint");
/**
 * Retrieves a single endpoint.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.EndpointService.GetEndpoint
 */
export const EndpointService_GetEndpoint = new RPC<GetEndpointRequest,GetEndpointResponse>("GET", "/v2/{name=workspaces/*/endpoints/*}");
/**
 * Lists endpoints.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.EndpointService.ListEndpoints
 */
export const EndpointService_ListEndpoints = new RPC<ListEndpointsRequest,ListEndpointsResponse>("GET", "/v2/{parent=workspaces/*}/endpoints");
/**
 * Counts endpoints.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.EndpointService.CountEndpoints
 */
export const EndpointService_CountEndpoints = new RPC<CountEndpointsRequest,CountEndpointsResponse>("GET", "/v2/{parent=workspaces/*}/endpoints:count");
/**
 * Updates an endpoint.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.EndpointService.UpdateEndpoint
 */
export const EndpointService_UpdateEndpoint = new RPC<UpdateEndpointRequest,UpdateEndpointResponse>("PATCH", "/v2/{endpoint.name=workspaces/*/endpoints/*}", "endpoint");
/**
 * Deletes an endpoint.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.EndpointService.DeleteEndpoint
 */
export const EndpointService_DeleteEndpoint = new RPC<DeleteEndpointRequest,DeleteEndpointResponse>("DELETE", "/v2/{name=workspaces/*/endpoints/*}");
